import React, {useEffect, useLayoutEffect, useRef} from "react";
// @ts-ignore
import {Previewer} from "pagedjs";
import DashboardReport from "./DashboardReportWrapper";
import {isProd, queryParam} from "utils/utils";
import {useGetDashboard} from "api/api-hooks/dashboards-hooks";

const PROD_GENERATION_TIMEOUT = 20000
const DEV_GENERATION_TIMEOUT = 5000
const GEN_DELAY = 1000

const REPORT_EVT = "dashboard-report-status";

declare global {
    interface Window {
        loadedPreview: boolean;
        reportGenStart: Date;
    }

    interface Element {
        style: any;
    }
}

export const DashboardReportViewPaged = () => {
    const dashboardId = parseInt(queryParam("dashboardId")!!);
    const referenceTime = queryParam("referenceTime");
    const isBot = queryParam("robot") === "true";

    const query = useGetDashboard(dashboardId);
    const reportOptions = query.data?.reportOptions;

    const loadingTimoutRef = useRef<NodeJS.Timeout | null>(null);

    const isValid = () => {
        if(!referenceTime) return false;

        // Check if date valid
        const date = new Date(referenceTime);
        return !isNaN(date.getTime());
    };

    const reportFinishCallback = (status: "finished" | "error") => {
        console.log("finishCallback", status);

        if(loadingTimoutRef.current) clearTimeout(loadingTimoutRef.current);

        if(status === "error") {
            window.dispatchEvent(new CustomEvent(REPORT_EVT, {detail: "error"}));

            if(!isBot) {
                alert("Error generating report. Some component failed");
            }
        }

        if(status === "finished") {
            setTimeout(() => {
                renderPagePreview();
            }, GEN_DELAY);
        }
    }


    const renderPagePreview = () => {
        window.loadedPreview = true;
        window.reportGenStart = new Date();

        console.log(`Render start time: ${window.reportGenStart.toISOString()}`);

        const rootEl = document.querySelector("#root")!!;
        const pagedPreviewEl = document.querySelector("#preview-paged")!!;

        // Inline style for pagedjs margin sizes

        const previewer = new Previewer();
        previewer.preview(
            rootEl.innerHTML,
            [`${window.jsBasePath}/assets/reports/core.css`, pagedJsStyleInline],
            pagedPreviewEl
        ).then((flow: any) => {
            document.querySelector("#dashboard-report-wrapper-paged")!!.style.display = "none";

            const genEndTime = new Date()
            const elapsedSeconds = Math.round((genEndTime.getTime() - window.reportGenStart.getTime()) / 1000);

            console.log(`Render end time ${genEndTime.toISOString()}`);
            console.log(`Rendered total ${flow.total} pages. Took ${elapsedSeconds} seconds.`);

            window.dispatchEvent(new CustomEvent(REPORT_EVT, {detail: "finished"}));

            if(!isBot) {
                alert("Finished generating report preview");
            }
        })
    }

    const pagedJsStyleInline= { [window.location.href]:
            `@page {
                size: ${reportOptions!!.pageLayout?.format?.pageSize ?? "A4"} ${(reportOptions!!.pageLayout?.format?.orientation ?? "PORTRAIT").toLowerCase()};
                margin-top: ${reportOptions!!.pageLayout?.margins?.top ?? "20mm"};
                margin-bottom: ${reportOptions!!.pageLayout?.margins?.bottom ?? "20mm"};
                margin-left: ${reportOptions!!.pageLayout?.margins?.left ?? "20mm"};
                margin-right: ${reportOptions!!.pageLayout?.margins?.right ?? "20mm"};
                padding-top: ${reportOptions!!.pageLayout?.paddings?.top ?? "0"};
                padding-bottom: ${reportOptions!!.pageLayout?.paddings?.bottom ?? "0"};
                padding-left: ${reportOptions!!.pageLayout?.paddings?.left ?? "0"};
                padding-right: ${reportOptions!!.pageLayout?.paddings?.right ?? "0"};
            }
        `}

    useEffect(() => {
        console.log("Robot?", isBot);
    }, []);


    useLayoutEffect(() => {
        if(!isValid()) return;
        if(!query.data) return;
        if(window.loadedPreview) return;

        loadingTimoutRef.current = setTimeout(() => {
            window.dispatchEvent(new CustomEvent(REPORT_EVT, {detail: "error"}));
            const errMsg: string = "Report generation reached timeout. Some components taking longer than expected to load"
            if(!isBot) { alert(errMsg) }
        }, isProd() ? PROD_GENERATION_TIMEOUT : DEV_GENERATION_TIMEOUT);

        return () => {
            if(loadingTimoutRef.current) clearTimeout(loadingTimoutRef.current);
        }
    });

    return <React.Fragment>
        {!isValid() && <div>Invalid report options (missing or invalid referenceTime)</div>}

        { isValid() && !query.data && "Loading..." }

        { isValid() && query.data &&
            <DashboardReport dashboard={query.data} referenceTime={referenceTime!!} finishCallback={reportFinishCallback}/>
        }
    </React.Fragment>
};

